import Typography from "@mui/material/Typography";
import TextFieldStyled from "@/components/TextFieldStyled";
import {GenreSelectorMultiple} from "@/components/bandcreate/GenreSelectorMultiple";
import YearPicker from "@/components/YearPicker";
import CheckboxStyled from "@/components/CheckboxStyled";

const NetworkLocationFormFestivals = ({onChange}) => {

    const handleInputChanged = (event, value) => {
        if (onChange && typeof onChange === "function") {
            onChange(event, value);
        }
    }

    const handleCheckboxChanged = (event) => {
        event.target.value = event.target.checked;

        if (onChange && typeof onChange === "function") {
            onChange(event);
        }
    };

    return (
        <>
            <Typography variant="h4" component="p" color="common.black" sx={{ mt: 4,}}>
                Orts-spezifische Angaben (Festivals)
            </Typography>
            <TextFieldStyled
                type="number"
                name="visitors"
                label="Besucherzahlen"
                placeholder="50000"
                onChange={handleInputChanged}
            />
            <GenreSelectorMultiple
                label="Genre *"
                hint="Wähle bis zu drei"
                onChange={handleInputChanged}
            />
            <TextFieldStyled
                type="number"
                name="duration"
                label="Dauer in Tagen"
                placeholder="3"
                onChange={handleInputChanged}
            />
            <YearPicker
                name="year_established"
                label="Gründungsjahr"
                onChange={handleInputChanged}
                MenuProps="YearPicker"
            />
            <CheckboxStyled
                label="Dieser Ort hat eine Bühne für Konzerte / Live-Programm"
                name="live"
                onChange={handleCheckboxChanged}
                marginTop
            />
            <CheckboxStyled
                label="Dieser Ort bietet Auftrittsmöglichkeiten für DJs"
                name="dj"
                onChange={handleCheckboxChanged}
                marginTop
            />
        </>
    )
}

export default NetworkLocationFormFestivals;
